import { startCase, toLower } from "lodash";

export const getHoldingsTypeString = (type: string | null): string | null => {
  if (!type) {
    return null;
  }
  if (type.toLowerCase() === "etf") {
    return "ETF";
  }

  return startCase(toLower(type));
};
